import {SpecificationVehiclesValueObject} from './SpecificationVehiclesValueObject.js'

export class ModelSpecificationVehiclesValueObject extends SpecificationVehiclesValueObject {
  constructor({icon, id, name}) {
    super(icon, id, name)
  }

  static createFromId({id}) {
    if (!this.isValidId({id})) return ModelSpecificationVehiclesValueObject.empty()

    // Missing icon and name until we have local dictorionary to get them
    return new ModelSpecificationVehiclesValueObject({
      id
    })
  }
}
